// extracted by mini-css-extract-plugin
export default {"note":"Note_note__p7hW4"};